"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pressure = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.pressure = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'pressure',
    variableName: VariableName_1.VariableName.pressure,
    dbTable: tsdb_1.TSDBTable.pressure,
    title: 'Pressure',
    icon: free_solid_svg_icons_1.faWeight,
    isSlotted: true,
    order: 4,
    graphQLSampleKey: 'pressure',
    bucketing: {
        min: 95000,
        max: 105000,
        numberOfBuckets: 6,
    },
    colormap: [
        { value: 100000, rgb: [250, 25, 25, 1] },
        { value: 102600, rgb: [25, 25, 250, 1] },
    ],
    dataPointConverter: x => x / 100,
    unit: 'hPa',
    decimals: 1,
};
//# sourceMappingURL=pressure.js.map